export const AuditEvent = {
    MemberPortalViewContactUs: 'MemberPortalViewContactUs',
    MemberPortalViewBenefits: 'MemberPortalViewBenefits',
    MemberPortalViewFaq: 'MemberPortalViewFaq',
    MemberPortalViewExplanationOfBenefits: 'MemberPortalViewExplanationOfBenefits',
    MemberPortalViewClaims: 'MemberPortalViewClaims',
    MemberPortalViewIdCard: 'MemberPortalViewIdCard',
    MemberPortalViewAccountInformation: 'MemberPortalViewAccountInformation',
    MemberPortalSSOToAmericanLogistics: 'MemberPortalSSOToAmericanLogistics',
    MemberPortalSSOtoSaferide: 'MemberPortalSSOtoSaferide',
} as const;

export type AuditEventType = typeof AuditEvent[keyof typeof AuditEvent];
